<template>
    <div class="container">
        <el-dialog
            title="统计图"
            :visible.sync="showkicper"
            width="1200px"
            @close="back">

            <div class="base-warp">
                <div class="head">
                    <el-form label-width="80px" :inline="true" size="mini">
                        <el-form-item label="选择日期">
                            <el-date-picker
                            v-model="checkdate"
                            type="daterange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            value-format="yyyy-MM-dd"
                            @change="datechange">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="search">查询</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="table-box">
                    <el-row>
                        <el-col :span="16" :offset="0">
                            <div id="chart"></div>
                        </el-col>
                        <el-col :span="8" :offset="0">
                            <div id="cake"></div>
                        </el-col>
                    </el-row>
                </div>
            </div>

        </el-dialog>
    </div>
</template>

<script>
// let echarts = require('echarts')
// import echarts from 'echarts'
// require('echarts/lib/chart/bar')
// require('echarts/lib/component/tooltip')
// require('echarts/lib/component/title')
export default {
    data() {
        return {
            showkicper: true,
            checkdate: [],
            columnsData: [],
            opinionData: [],
            opinionData2: [],
            opinionData3: [],
            charts: '',
            cakes: '',
        }
    },
    mounted () {
        this.$nextTick(function(){
            this.drawLine();
        })
        this.getDate();
    },
    methods: {
        gettabledata() {
            var params = {
                checkdate: JSON.stringify(this.checkdate),
            }
            this.$api.getclientsStatistics(params).then(
                data=>{
                    let {columns, opinionData, opinionData2, opinionData3} = data;
                    this.columnsData = columns;
                    this.opinionData = opinionData;
                    this.opinionData2 = opinionData2;
                    this.opinionData3 = opinionData3;
                    this.drawcake();
                    this.drawLine();
                }
            )
        },
        getDate() {
            var date = new Date();
            var yyyy = date.getFullYear();
            var month = date.getMonth()+1;
            var day = date.getDate();
            if (month<10) month='0'+month;
            if (day<10) day = '0'+day;
            var today = yyyy+'-'+month+'-'+day;

            // console.log(today)

            var times = date.getTime()-7*1000*60*60*24;
            var fdate = new Date(times);
            var yyyy1 = fdate.getFullYear();
            var month1 = fdate.getMonth()+1;
            var day1 = fdate.getDate();
            if (month1<10) month1='0'+month1;
            if (day1<10) day1='0'+day1
            var ftoday = yyyy1+'-'+month1+'-'+day1;
            this.checkdate = [ftoday, today];
            this.gettabledata();
        },
        back() {
            this.$router.go(-1);
        },
        search() {
            this.gettabledata();
        },
        datechange() {
            console.info(this.checkdate)
        },
        drawcake() {
            this.cakes = echarts.init(document.getElementById('cake'));
            this.cakes.setOption({
                title: {
                    text: '来源权重比',
                    // x 设置水平安放位置，默认左对齐，可选值：'center' ¦ 'left' ¦ 'right' ¦ {number}（x坐标，单位px）
                    x: 'center',
                    // y 设置垂直安放位置，默认全图顶端，可选值：'top' ¦ 'bottom' ¦ 'center' ¦ {number}（y坐标，单位px）
                    y: 'top',
                    // itemGap设置主副标题纵向间隔，单位px，默认为10，
                    itemGap: 20,
                    backgroundColor: '#EEE',
                    // 主标题文本样式设置
                    textStyle: {
                        fontSize: 16,
                        // fontWeight: 'bolder',
                        color: '#f56c6c'
                    },
                    // 副标题文本样式设置
                    subtextStyle: {
                        fontSize: 18,
                        color: '#8B2323'
                    }
                },
                legend: {
                    // orient 设置布局方式，默认水平布局，可选值：'horizontal'（水平） ¦ 'vertical'（垂直）
                    orient: 'vertical',
                    // x 设置水平安放位置，默认全图居中，可选值：'center' ¦ 'left' ¦ 'right' ¦ {number}（x坐标，单位px）
                    x: 'right',
                    // y 设置垂直安放位置，默认全图顶端，可选值：'top' ¦ 'bottom' ¦ 'center' ¦ {number}（y坐标，单位px）
                    y: 'bottom',
                        itemWidth: 24,   // 设置图例图形的宽
                        itemHeight: 18,  // 设置图例图形的高
                        textStyle: {
                        color: '#666'  // 图例文字颜色
                    },
                    // itemGap设置各个item之间的间隔，单位px，默认为10，横向布局时为水平间隔，纵向布局时为纵向间隔
                    itemGap: 10,
                    backgroundColor: '#eee',  // 设置整个图例区域背景颜色
                    data: ['真会投资', '新媒/公众号', '新媒/抖音', '嘟嘟租房', '亿房', '其他']
                },
                series : [
                    {
                        name: '来源权重比',
                        radius: ['20%', '50%'],  // 设置环形饼状图， 第一个百分数设置内圈大小，第二个百分数设置外圈大小
                        name: '访问来源',
                        type: 'pie',    // 设置图表类型为饼图
                        data:  this.opinionData3,
                        itemStyle: {
                            // emphasis：英文意思是 强调;着重;（轮廓、图形等的）鲜明;突出，重读
                            // emphasis：设置鼠标放到哪一块扇形上面的时候，扇形样式、阴影
                            emphasis: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(30, 144, 255，0.5)'
                            }
                        },
                        // 设置值域的那指向线
                        labelLine: {
                            normal: {
                                show: true   // show设置线是否显示，默认为true，可选值：true ¦ false
                            }
                        },
                        // 设置值域的标签
                        label: {
                            normal: {
                                position: 'inner（饼状图上）',  // 设置标签位置，默认在饼状图外 可选值：'outer' ¦ 'inner（饼状图上）'
                                // formatter: '{a} {b} : {c}个 ({d}%)'   设置标签显示内容 ，默认显示{b}
                                // {a}指series.name  {b}指series.data的name
                                // {c}指series.data的value  {d}%指这一部分占总数的百分比
                                formatter: '{b}-{c}',
                            },
                        }
                    }
                ],
                
            })
        },
        drawLine() {
            this.charts = echarts.init(document.getElementById('chart'))
            this.charts.setOption({
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: ['当日新增客户', '客户总数']
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },

                toolbox: {
                    // feature: {
                    //     saveAsImage: {}
                    // }
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: this.columnsData,
                },
                yAxis: [
                    {
                        type: 'value',
                    },
                    {
                        type: 'value',
                    }
                ],
                series: [
                    {
                        name: '当日新增客户',
                        type: 'line',
                        // stack: '总量',
                        smooth: 0.4,
                        yAxisIndex: 1,
                        data: this.opinionData
                    },
                    {
                        name: '客户总数',
                        type: 'line',
                        smooth: 0.4,
                        // stack: '总量',
                        data: this.opinionData2
                    },
                ]
            })
        },
    },
}
</script>

<style lang="scss" scoped>
#chart{
    width: 100%;
    height: 600px;
}
#cake{
    width: 100%;
    height: 600px;
}
</style>